import { render, staticRenderFns } from "./valentineGarden.vue?vue&type=template&id=c4997db8"
import script from "./valentineGarden.vue?vue&type=script&lang=js"
export * from "./valentineGarden.vue?vue&type=script&lang=js"
import style0 from "./valentineGarden.vue?vue&type=style&index=0&id=c4997db8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports